module.exports = __webpack_public_path__ + "img/czsc_14.3a480497.png";